

import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from "axios";
import toast from "react-hot-toast";
import { BASE_URL } from '../config';
import { useDispatch } from "react-redux";
import { setAuthUser } from '../redux/userSlice';

const GuestAccess = () => {
  // console.log("hii")
  const [user, setUser] = useState({
    username: "",
    mobileNumber: "",
       email: "" 
  });

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ✅ Read query parameters and pre-fill the form
  useEffect(() => {
    const name = searchParams.get("name");
    const mobile = searchParams.get("mobile_no");
      const email = searchParams.get("email"); 
  

    if (name && mobile) {
      setUser({
        username: name,
        mobileNumber: mobile,
          email: email || "" // Set email if available
         
      });
    }
  }, [searchParams]);

  // ✅ Auto-submit form once pre-filled
  useEffect(() => {
    const autoSubmit = async () => {
      if (user.username && user.mobileNumber) {
        try {

          const tokenRes = await axios.get(`${BASE_URL}/api/v1/auth/verify-token`);
          if (!tokenRes.data?.status) {
            toast.error("Invalid authentication. Access denied.");
            return;
          }


          const res = await axios.post(`${BASE_URL}/api/v1/user/guest`, user, {
            headers: {
              'Content-Type': 'application/json'
            },
            withCredentials: true
          });

          dispatch(setAuthUser(res.data));
         
          navigate("/");

        } catch (error) {
          toast.error(error.response?.data?.message || "Something went wrong");
          console.log(error);
        }
      }
    };

    autoSubmit();
  }, [user.username, user.mobileNumber, user.email]);
 
  return (
    // console.log("hii")
    <div >
                  {/* 
       <div className='w-full p-6 rounded-lg shadow-md bg-gray-400 bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-10 border border-gray-100'>
       <h1 className='text-3xl font-bold text-center'>Welcome</h1>
        <form>
          <div>
            <label className='label p-2'>
              <span className='text-base label-text'>Username</span>
            </label>
            <input 
              value={user.username}
              onChange={(e) => setUser({ ...user, username: e.target.value })}
              className='w-full input input-bordered h-10'
              type="text"
              placeholder='Username'
              required />
          </div>
          <div>
            <label className='label p-2'>
              <span className='text-base label-text'>Mobile Number</span>
            </label>
            <input
              value={user.mobileNumber}
              onChange={(e) => setUser({ ...user, mobileNumber: e.target.value })}
              className='w-full input input-bordered h-10'
              type="tel"
              placeholder='Mobile Number'
              pattern="[0-9]{10}"
              maxLength="10"
              title="Enter a valid 10-digit mobile number"
              required />
          </div>

          <p className='text-center my-2'><strong> Admin? </strong> <Link to="/login">Login here</Link></p>
        </form> 
      </div>  */}
    </div>
  );
};

export default GuestAccess;
